<template>
  <div class="d-flex flex-column">
    <div v-for="option in options" :key="option.id" class="d-flex align-items-center mb-1">
      <b-form-input
        v-model.trim="option.value"
        class="ml-1"
        size="sm"
        placeholder="Введите текст варианта ответа"
        @change="saveOption({ id: option.id, value: option.value })"
      />
      <b-icon-x @click="deleteOption(option.id)" class="remove-option ml-1" />
    </div>

    <div class="add-option mt-3" @click="addOption">Добавить вариант ответа</div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/custom/colors.scss";
.add-option {
  font-size: 12px;
  width: fit-content;
  cursor: pointer;
  color: $primary;
  &:hover {
    color: $primary-700;
  }
}
.remove-option {
  cursor: pointer;
  &:hover {
    background: #eee;
    border-radius: 0.25rem;
  }
}
</style>

<script>
import { BIconX } from "bootstrap-vue";
import Api from "shared/service/api/api";

export default {
  name: "LessonSurveyQuestionOptions",
  components: { BIconX },
  props: {
    questionId: {
      type: Number,
      required: true,
    },
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lessonId() {
      return Number(this.$route.params.lessonId);
    },
    apiNamespace() {
      return this.isManage ? Api.admin.course.lesson.survey.question.option : Api.course.lesson.survey.question.option;
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.apiNamespace.all(this.lessonId, this.questionId).then((response) => {
        this.options = response.data;
      });
    },
    addOption() {
      this.apiNamespace
        .create(this.lessonId, this.questionId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.load();
        })
        .catch((e) => this.$alert.error("Ошибка создания ответа<br>" + e.message));
    },
    saveOption(option) {
      return this.apiNamespace
        .save(this.lessonId, option)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          !option.id && this.options.push({ ...response.data, ...option });
        })
        .catch((e) => this.$alert.error("Ошибка сохранения ответа<br>" + e.message))
        .finally(() => {
          this.load();
        });
    },
    deleteOption(optionId) {
      this.apiNamespace
        .delete(this.lessonId, optionId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.options = this.options.filter((a) => a.id !== optionId);
        })
        .catch((e) => this.$alert.error("Ошибка удаления варианта ответа"));
    },
  },
};
</script>
